import { registerApplication, start } from "single-spa";
const authToken = localStorage.getItem("authToken") || "";

registerApplication(
  "countries",
  // @ts-ignore
  () => import("countries/Countries"),
  (location) => authToken !== "" && location.hash.startsWith("#/countries")
);

registerApplication(
  "claims",
  // @ts-ignore
  () => import("claims/Claims"),
  (location) => authToken !== "" && location.hash.startsWith("#/claims")
);

registerApplication(
  "postalRates",
  // @ts-ignore
  () => import("postalRates/PostalRate"),
  (location) => authToken !== "" && location.hash.startsWith("#/postalRate")
);

registerApplication(
  "invoices",
  // @ts-ignore
  () => import("invoices/Invoices"),
  (location) => authToken !== "" && location.hash.startsWith("#/invoice")
);

registerApplication(
  "countryGroups",
  // @ts-ignore
  () => import("countryGroups/CountryGroups"),
  (location) => authToken !== "" && location.hash.startsWith("#/countryGroups"),
);

registerApplication(
  "navigation",
  // @ts-ignore
  () => import("navigation/Sidebar"),
  (location) => authToken !== "" && location.hash.startsWith("#/")
);
registerApplication(
  "statisticals",
  // @ts-ignore
  () => import("statisticals/Statistical"),
  (location) => authToken !== "" && location.hash.startsWith("#/statistical")
);

registerApplication(
  "currencies",
  // @ts-ignore
  () => import("currencies/Currency"),
  (location) => authToken !== "" && location.hash.startsWith("#/currency")
);

registerApplication(
  "exchangeRates",
  // @ts-ignore
  () => import("exchangeRates/CurrencyExchangeRates"),
  (location) => authToken !== "" && location.hash.startsWith("#/exchangeRates")
);

registerApplication(
  "postalOperators",
  // @ts-ignore
  () => import("postalOperators/PostalOperator"),
  (location) => authToken !== "" && location.hash.startsWith("#/postalOperator")
);

registerApplication(
  "settlements",
  // @ts-ignore
  () => import("settlements/Settlement"),
  (location) => authToken !== "" && location.hash.startsWith("#/settlement")
);

registerApplication(
  "offices",
  // @ts-ignore
  () => import("offices/Offices"),
  (location) => authToken !== "" && location.hash.startsWith("#/offices")
);

registerApplication(
  "exchanges",
  // @ts-ignore
  () => import("exchanges/Exchange"),
  (location) => authToken !== "" && location.hash.startsWith("#/exchange")
);

registerApplication(
  "companyCodes",
  // @ts-ignore
  () => import("companyCodes/CompanyCode"),
  (location) => authToken !== "" && location.hash.startsWith("#/companyCode")
);

registerApplication(
  "mailSubClasses",
  // @ts-ignore
  () => import("mailSubClasses/MailSubClass"),
  (location) => authToken !== "" && location.hash.startsWith("#/mailSubClass")
);

registerApplication(
  "emirates",
  // @ts-ignore
  () => import("emirates/Emirate"),
  (location) => authToken !== "" && location.hash.startsWith("#/emirate")
);

registerApplication(
  "officeTypes",
  // @ts-ignore
  () => import("officeTypes/OfficeTypes"),
  (location) => authToken !== "" && location.hash.startsWith("#/officeTypes")
);

registerApplication(
  "postalZones",
  // @ts-ignore
  () => import("postalZones/PostalZones"),
  (location) => authToken !== "" && location.hash.startsWith("#/postalZones")
);
registerApplication(
  "carriers",
  // @ts-ignore
  () => import("carriers/Carrier"),
  (location) => authToken !== "" && location.hash.startsWith("#/carrier")
);

registerApplication(
  "airlineSectors",
  // @ts-ignore
  () => import("airlineSectors/AirlineSector"),
  (location) => authToken !== "" && location.hash.startsWith("#/airlineSector")
);

registerApplication(
  "airports",
  // @ts-ignore
  () => import("airports/Airports"),
  (location) => authToken !== "" && location.hash.startsWith("#/airports")
);

registerApplication(
  "companies",
  // @ts-ignore
  () => import("companies/Companies"),
  (location) => authToken !== "" && location.hash.startsWith("#/companies")
);

registerApplication(
  "usermanagement",
  // @ts-ignore
  () => import("usermanagement/UserManagement"),
  (location) => authToken !== "" && location.hash === "#/userAdministrations"
);

registerApplication(
  "tripTracking",
  // @ts-ignore
  () => import("tripTracking/TripTracking"),
  (location) => authToken !== "" && location.hash === "#/tripTracking"
);

registerApplication(
  "liveTracking",
  // @ts-ignore
  () => import("liveTracking/LiveTracking"),
  (location) => authToken !== "" && location.hash === "#/liveTracking"
);

registerApplication(
  "dashboard",
  // @ts-ignore
  () => import("dashboard/Dashboard"),
  (location) => authToken !== "" && location.hash === "#/dashboard"
);

registerApplication(
  "login",
  // @ts-ignore
  () => import("login/Login"),
  (location) => {
    return (
      authToken === "" &&
      (location.pathname.startsWith("/") || location.hash.startsWith("#/login"))
    );
  }
);

registerApplication(
  "accountingDashboard",
  // @ts-ignore
  () => import("accountingDashboard/Dashboard"),
  (location) => authToken !== "" && location.hash === "#/accounting/dashboard"
);

registerApplication(
  "routeDefinition",
  // @ts-ignore
  () => import("routeDefinition/RouteDefinition"),
  (location) =>
    authToken !== "" && location.hash.startsWith("#/locationmasters/routeDefinition")
);

registerApplication(
  "zoneSortingDefinition",
  // @ts-ignore
  () => import("routeDefinition/RouteDefinition"),
  (location) =>
    authToken !== "" &&
    location.hash.startsWith("#/locationmasters/routeDefinition/zoneSortingDefinition")
);

registerApplication(
  "facilityDefinition",
  // @ts-ignore
  () => import("facilityDefinition/FacilityDefinition"),
  (location) =>
    authToken !== "" && location.hash === "#/locationmasters/facilityDefinition"
);

registerApplication(
  "territoryDefinition",
  // @ts-ignore
  () => import("territoryDefinition/TerritoryDefinition"),
  (location) =>
    authToken !== "" &&
    location.hash.startsWith("#/locationmasters/territoryDefinition")
);

registerApplication(
  "sectorsDefinition",
  // @ts-ignore
  () => import("territoryDefinition/TerritoryDefinition"),
  (location) =>
    authToken !== "" &&
    location.hash.startsWith("#locationmasters/territoryDefinition/sectors")
);

registerApplication(
  "locationBarcodes",
  // @ts-ignore
  () => import("territoryDefinition/TerritoryDefinition"),
  (location) =>
    authToken !== "" && location.hash === "#locationmasters/territoryDefinition/locationBarcodes"
);

registerApplication(
  "routeCoverage",
  // @ts-ignore
  () => import("territoryDefinition/TerritoryDefinition"),
  (location) =>
    authToken !== "" &&
    location.hash.startsWith("#locationmasters/territoryDefinition/routeCoverage")
);

registerApplication(
  "zoneDefinition",
  // @ts-ignore
  () => import("facilityDefinition/ZoneDefinition"),
  (location) =>
    authToken !== "" && location.hash === "#/locationmasters/zoneDefinition"
);


registerApplication(
  "users",
  // @ts-ignore
  () => import("users/Users"),
  (location) => authToken !== "" && location.hash === "#/users"
);

registerApplication(
  "roles",
  // @ts-ignore
  () => import("roles/Roles"),
  (location) => authToken !== "" && location.hash === "#/roles"
);

registerApplication(
  "permissions",
  // @ts-ignore
  () => import("permissions/Permissions"),
  (location) => authToken !== "" && location.hash === "#/permissions"
);

registerApplication(
  "sector",
  // @ts-ignore
  () => import("sector/Sector"),
  (location) => authToken !== "" && location.hash === "#/locationmasters/sector"
);

registerApplication(
  "routeList",
  // @ts-ignore
  () => import("routeList/RouteList"),
  (location) =>
    authToken !== "" && location.hash === "#/locationmasters/routeList"
);

registerApplication(
  "tripManagement",
  // @ts-ignore
  () => import("tripManagement/TripManagement"),
  (location) => authToken !== "" && location.hash === "#/tripManagement"
);

registerApplication(
  "cms",
  // @ts-ignore
  () => import("cms/CMS"),
  (location) => authToken !== "" && location.hash.startsWith("#/cms")
);

registerApplication(
  "ams",
  // @ts-ignore
  () => import("ams/AMS"),
  (location) => authToken !== "" && location.hash.startsWith("#/ams")
);

registerApplication(
  "unauthorised",
  // @ts-ignore
  () => import("navigation/Unauthorised"),
  (location) => authToken !== "" && location.hash.startsWith("#/unauthorised")
);

registerApplication(
  "profile",
  // @ts-ignore
  () => import("navigation/Profile"),
  (location) => authToken !== "" && location.hash.startsWith("#/profile")
);

registerApplication(
  "liabilityAccount",
  // @ts-ignore
  () => import("liabilityAccount/LiabilityAccount"),
  (location) => authToken !== "" && location.hash === "#/liabilityAccount"
);

registerApplication(
  "supplierMapping",
  // @ts-ignore
  () => import("supplierMapping/SupplierMapping"),
  (location) => authToken !== "" && location.hash === "#/supplierMapping"
);

registerApplication(
  "countryDetail",
  // @ts-ignore
  () => import("countryDetail/CountryDetail"),
  (location) => authToken !== "" && location.hash === "#/countryDetail"
);

registerApplication(
  "tallyReport",
  // @ts-ignore
  () => import("tripManagement/TripManagement"),
  (location) => authToken !== "" && location.hash === "#/tallyReport"
);

registerApplication(
  "debriefing",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/debriefing")
);

registerApplication(
  "voucher",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/voucher")
);

registerApplication(
  "bankDetails",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/bank-details")
);

registerApplication(
  "productGroup",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/product-group")
);

registerApplication(
  "product",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/product")
);

registerApplication(
  "contentType",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/content-type")
);

registerApplication(
  "sla",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/sla")
);

registerApplication(
  "addon",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/addon")
);

registerApplication(
  "communicationChannel",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) =>
    authToken !== "" &&
    /^#\/communication-channel(\/|$)/.test(location.hash)
);

registerApplication(
  "communicationLog",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) =>
    authToken !== "" &&
    /^#\/communication-log(\/|$)/.test(location.hash)
);

registerApplication(
  "communication",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) =>
    authToken !== "" &&
    /^#\/communication(\/|$)/.test(location.hash)
);

registerApplication(
  "shipmentWithErrors",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/shipment-withErrors")
);

registerApplication(
  "shipment",
  // @ts-ignore
  () => import("shipment/Shipment"),
  (location) => authToken !== "" && location.hash.startsWith("#/shipment")
);

registerApplication(
  "pickup",
  // @ts-ignore
  () => import("pickup/Pickup"),
  (location) => authToken !== "" && location.hash.startsWith("#/pickup")
);

registerApplication(
  "identityType",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/identity-type")
);

registerApplication(
  "pickupType",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/pickup-type")
);

registerApplication(
  "deliveryType",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/delivery-type")
);

registerApplication(
  "transportType",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/transport-type")
);

registerApplication(
  "productClassificiation",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/product-classificiation")
);

registerApplication(
  "mainStatus",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/main-status")
);

registerApplication(
  "subStatus",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/sub-status")
);

registerApplication(
  "finesReport",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/fines-report")
);

registerApplication(
  "ddpCharges",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/ddp-charges")
);

registerApplication(
  "customsShipment",
  // @ts-ignore
  () => import("debriefing/Debriefing"),
  (location) => authToken !== "" && location.hash.startsWith("#/customs-shipment")
);

registerApplication(
  "controlTower",
  // @ts-ignore
  () => import("controlTower/ControlTower"),
  (location) => authToken !== "" && location.hash.startsWith("#/control-tower-realtime-dashboard")
);

registerApplication(
  "vms",
  // @ts-ignore
  () => import("vms/VMS"),
  (location) => authToken !== "" && location.hash.startsWith("#/vms")
);

registerApplication(
  "rewards",
  // @ts-ignore
  () => import("rewards/Rewards"),
  (location) => authToken !== "" && location.hash.startsWith("#/rewards")
);

registerApplication(
  "utilization",
  // @ts-ignore
  () => import("rewards/Rewards"),
  (location) => authToken !== "" && location.hash.startsWith("#/courier-utilization")
);

start({ urlRerouteOnly: true });
